export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.eot?0fea24969112a781acd2463caf03f138";